import { render, staticRenderFns } from "./ContentCopy.vue?vue&type=template&id=0e8bd3c4"
import script from "./ContentCopy.vue?vue&type=script&lang=js"
export * from "./ContentCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports